// ======================================================================
// File Name       : ContentDrillSkinSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button } from 'react-bootstrap';
import { VALIDATE_TYPE } from '../../constants/index';
import FormControlValidate from '../FormControlValidate';
import CustomButton from '../button/CustomButton';
import * as Path from '../../constants/PathConstants';
import * as FUNCTION from '../../constants/FunctionConstants';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../button/CustomLink';
import { canAccessRoute } from '../../utils/AuthedUtils';

class ContentDrillSkinSearch extends React.Component {
  constructor() {
    super();
    this.validation = this.validation.bind(this);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    const {
      skinSetSecernId,
      skinSetName,
      recordNum,
      startPosition,
      handleChange,
      getStartEndData,
      onSearchBtnClick,
      onOptionSkinInsertClick, // #7080
    } = this.props;
    this.refsToValidate = [];
    const canAccessRegister = canAccessRoute(FUNCTION.CONTENT_DRILL_SKIN_REGISTER);
  
    return (
      <div>
        <p className="margin-top-10">検索する項目を指定してください</p>
        <Form onSubmit={(e) => { e.preventDefault(); onSearchBtnClick(); }} className='form-horizontal'>
          <Col sm={12} className="padding-top-10">
            <Form.Group className="form-info" controlId="formHorizontalSkinSetSecernId">
              <Col as={Form.Label} sm={3}>
                スキン識別ID
              </Col>
              <Col sm={7}>
                <FormControlValidate
                  label="スキン識別ID"
                  type="text"
                  name="skinSetSecernId"
                  value={skinSetSecernId}
                  maxLength="64"
                  validateType={VALIDATE_TYPE.ID}
                  onChange={handleChange}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info" controlId="formHorizontalSkinSetName">
              <Col as={Form.Label} sm={3}>
                スキン名
              </Col>
              <Col sm={7}>
                <FormControl
                  type="text"
                  maxLength="256"
                  name="skinSetName"
                  onChange={handleChange}
                  value={skinSetName}
                />
              </Col>
            </Form.Group>
          </Col>
          <Form.Group>
            <Col sm={12} className="text-center margin-top-10">
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                type="submit"
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
          <Form.Group>
            {/* #7080 START */}
            <Col sm={12} className="inline-flex margin-bottom-10 margin-top-10">
              {canAccessRegister && (
                <CustomLink
                  className="margin-right-7 btn-register margin-right-10"
                  to={Path.CONTENT_DRILL_SKIN_REGISTER}
                  text="スキン追加"
                  icon={ICON.REGIST}
                />
              )}
              <CustomButton
                  btnStyle="btn-export-csv"
                  handleClick={onOptionSkinInsertClick}
                  text="オプションスキン追加"
              />
            </Col>
            {/* #7080 END */}
          </Form.Group>
        </Form>
      </div>
    );
  }
}

export default ContentDrillSkinSearch;
